export default __webpack_public_path__ + "static/stock3-67a083cc50763e8924326586cbba5491.jpg";